import React from 'react';
import { Grid } from '@mui/material';
import { moneyFormat } from 'helpers/moneyFormat';
import { ProcedureDoctor } from 'types/procedure';
import { RecordColumn, RecordList } from 'components/record-shell/RecordList';

interface ProcedureDoctorsListProps {
  doctors: ProcedureDoctor[];
  handleDeleteDoctor(doctor: ProcedureDoctor, index: number): void;
  handleEditDoctor(doctor: ProcedureDoctor, index: number): void;
}

const columns: RecordColumn[] = [
  { id: 'name', label: 'Médico' },
  { id: 'specialty', label: 'Especialidade' },
  { id: 'min', label: 'Mínimo', shortLabel: 'Mín', align: 'right', width: '120px' },
  { id: 'max', label: 'Máximo', shortLabel: 'Máx', align: 'right', width: '120px' },
];

const ProcedureDoctorsList: React.FC<ProcedureDoctorsListProps> = ({
  doctors,
  handleDeleteDoctor,
  handleEditDoctor,
}) => (
  <Grid size={12}>
    <RecordList
      columns={columns}
      rows={doctors.map((item, index) => ({
        key: item.id || index,
        values: {
          name: item.doctor?.name || 'Médico',
          specialty: [...new Set(item.doctor?.specialties || [])].join(', ') || '-',
          min: moneyFormat(item.sale_price_min),
          max: moneyFormat(item.sale_price_max),
        },
      }))}
      onEdit={index => handleEditDoctor(doctors[index], index)}
      onDelete={index => handleDeleteDoctor(doctors[index], index)}
    />
  </Grid>
);

export default ProcedureDoctorsList;
